<!DOCTYPE html>
@if(voucher) {
<div class="voucher-card">
  <div class="voucher-header">
    <img src="assets/images/ticket.png" alt="ticket" />
    <h6 class="voucher-text">{{ voucher?.percentage }}% {{ "breakdown.discount_voucher" | translate }}</h6> 
    @switch(voucher.claim_status) {
      @case('claim') {
        <button
          class="claim-button"
          [ngClass]="{ 'with-countdown': countdownSeconds }"
          (click)="claimVoucher()">
          {{ "breakdown.claim" | translate }}
          @if(countdownSeconds) {
            <span class="timer-text">{{ voucherNotificationService.claimTimerDisplay }}</span>
          }
        </button>
        @if(countdownSeconds) {
          <countdown-timer
            [seconds]="countdownSeconds"
            (formattedTime)="voucherNotificationService.claimTimerDisplay = $event"
            (countdownFinished)="handleCountdownFinish()">
          </countdown-timer>
        }
      }
      @case('claimed') {
        <div class="status-tag claimed">
          <span>{{ "breakdown.claimed" | translate }}</span>
          <img src="assets/icon/check-circle.svg" alt="check-circle" />
        </div>
      }
      @case('expired') {
        <div class="status-tag expired">
          {{ "breakdown.expired" | translate }}
        </div>
      }
    }
  </div>
  
  @if (voucher.claim_status === 'claimed') {
    <div class="discount-info">
      <span class="info-label">{{ "breakdown.use_discount" | translate }}</span>
      <div class="info-btn-wrapper">
        <ion-button class="info-btn" fill="outline" color="secondary" (click)="useDiscount()">
          {{ "breakdown.use_discount_now" | translate }}
        </ion-button>
      </div>
    </div>
  }
</div>
}